import { useEffect } from 'react';

import SavedEstimateList, {
  SavedEstimateListSkeleton,
} from '~/UI/components/organisms/SavedEstimateList';
import StoresList from '~/UI/components/organisms/StoresList';
import FullPageLoader from '~/UI/components/templates/FullPageLoader';
import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { getLocalData, removeLocalData } from '~/core/helpers/storageHelper';
import { useEstimateContext } from '~/legacy/easy-estimator-page/context/estimateContext';
import { useAppSelector } from '~/redux/hooks';
import { selectShowListOfEstimates } from '~/redux/slices/estimate';

const StorePage = (): JSX.Element => {
  const { isFetchingEstimate } = useEstimateContext();
  const showListOfEstimates = useAppSelector(selectShowListOfEstimates);
  const isEstimateCodeSwitch =
    getLocalData(LOCAL_STORAGE_KEY.ESTIMATE_CODE_SWITCH) === 'true';

  useEffect(() => {
    if (isEstimateCodeSwitch && showListOfEstimates) {
      removeLocalData(LOCAL_STORAGE_KEY.ESTIMATE_CODE_SWITCH);
    }
  }, [isEstimateCodeSwitch, showListOfEstimates]);

  if (isFetchingEstimate) {
    return <FullPageLoader />;
  }

  if (showListOfEstimates) {
    return <SavedEstimateList />;
  }

  if (isEstimateCodeSwitch) {
    return <SavedEstimateListSkeleton />;
  }

  return <StoresList />;
};

export default StorePage;
